import React from "react";

export const DashboardIcon = ({width = '20', height = '20', fill = '#93939E'}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.125" y="3.375" width="5.75" height="6.25" rx="1.575" stroke={fill} strokeWidth="1.25"/>
            <rect x="3.125" y="11.875" width="5.75" height="4.75" rx="1.575" stroke={fill} strokeWidth="1.25"/>
            <rect x="0.625" y="-0.625" width="5.75" height="6.25" rx="1.575" transform="matrix(1 0 0 -1 10.5 16)"
                  stroke={fill} strokeWidth="1.25"/>
            <rect x="0.625" y="-0.625" width="5.75" height="4.75" rx="1.575" transform="matrix(1 0 0 -1 10.5 7.5)"
                  stroke={fill} strokeWidth="1.25"/>
        </svg>
    );
}